import { render, staticRenderFns } from "./TournamentStandings.vue?vue&type=template&id=f1840ab0&scoped=true&"
import script from "./TournamentStandings.vue?vue&type=script&lang=js&"
export * from "./TournamentStandings.vue?vue&type=script&lang=js&"
import style0 from "./TournamentStandings.vue?vue&type=style&index=0&id=f1840ab0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1840ab0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1840ab0')) {
      api.createRecord('f1840ab0', component.options)
    } else {
      api.reload('f1840ab0', component.options)
    }
    module.hot.accept("./TournamentStandings.vue?vue&type=template&id=f1840ab0&scoped=true&", function () {
      api.rerender('f1840ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentStandings.vue"
export default component.exports